
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Outcome() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  const metrics = [
    {
      value: '30–50%',
      label: 'Reduction in manual intake workload',
      icon: 'ri-speed-up-line'
    },
    {
      value: '20–40%',
      label: 'Increase in appointment conversion rates',
      icon: 'ri-calendar-check-line'
    },
    {
      value: 'Real-Time',
      label: 'Operational visibility dashboards',
      icon: 'ri-dashboard-3-line'
    },
    {
      value: 'Scalable',
      label: 'Infrastructure built for expansion',
      icon: 'ri-expand-up-down-line'
    }
  ];

  return (
    <section className="py-28 md:py-40 bg-[#fafafa]">
      <div ref={ref} className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className={`text-center mb-20 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#D4AF37] mb-6">
            Results
          </p>
          <h2 className="text-4xl md:text-6xl font-serif text-[#1d1d1f] leading-[1.1]">
            Engineered for
            <br />
            <span className="text-[#86868b]">Measurable Growth</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {metrics.map((metric, index) => (
            <div
              key={index}
              className={`group text-center p-8 rounded-2xl bg-white border border-[#e8e8e8] hover:border-[#D4AF37]/30 transition-all duration-500 cursor-default ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: isVisible ? `${200 + index * 100}ms` : '0ms' }}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37]/10 rounded-xl mx-auto mb-5 group-hover:bg-[#D4AF37]/20 transition-colors duration-300">
                <i className={`${metric.icon} text-[#D4AF37] text-base`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-serif text-[#D4AF37] mb-2">
                {metric.value}
              </div>
              <p className="text-sm font-light text-[#86868b] leading-relaxed">
                {metric.label}
              </p>
            </div>
          ))}
        </div>

        <div className={`text-center mt-16 transition-all duration-700 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-lg md:text-xl font-serif text-[#1d1d1f] max-w-2xl mx-auto italic">
            When AI is structured correctly, performance becomes predictable.
          </p>
        </div>
      </div>
    </section>
  );
}
